(function() {
    'use strict';

    angular
        .module('functional7App')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
